/**
 * a list of phonemes for extinct language from various sources
 */
export const segmentsForExtinct: Record<string, string> = {
  // https://en.wikipedia.org/wiki/Proto-Indo-European_language#Phonology
  "Proto-Indo-European": "e o ē ō m n p t ḱ k kʷ b d ǵ g gʷ bʰ dʰ ǵʰ gʰ gʷʰ s h₁ h₂ h₃ r l y w",
  // https://en.wikipedia.org/wiki/Hittite_language#Phonology
  Hittite: "pː p tː t kː k kʷː kʷ mː m nː n rː r lː l sː a ʃː ʃ χː χ χʷː χʷ ts j w i u e o a",
  // https://en.wikipedia.org/wiki/Proto-Greek_language
  "Proto Greek": "m n ɲ p b pʰ t d tʰ c ɟ k g kʰ kʷ gʷ kʷʰ ts dz s h l r ľ ř j w i ī u ū e ē ə o ō a ā ai ei oi ui au eu ou āi ēi ōi",
  // https://en.wikipedia.org/wiki/Latin#Phonology
  Latin: "b d g ɡʷ p t k kʷ f s h m n r l j w iː ɪ ʊ uː eː ɛ ɔ oː a aː",
  // https://en.wikipedia.org/wiki/Old_English#Phonology
  // additional allophones: "n̥ ŋ ɡ dʒ v ð z ç h l̥ w̥ r̥",
  "Old English": "m n p b t d k tʃ f θ s ʃ x ɣ l j w r i iː y yː u uː e eː o oː æ æː ɑ ɑː",
  // https://en.wikipedia.org/wiki/Old_Church_Slavonic#Phonology
  "Old Church Slavonic": "p b t d k ɡ ts dz tʃ s z ʃ ʒ x m n nʲ l lʲ r rʲ v j ʃt i ɯ u ɪ ɨ e o æ a ẽ õ",

  // https://en.wikipedia.org/wiki/Sumerian_language#Phonology
  Sumerian: "m n ŋ p t k ʔ pʰ tʰ kʰ s ʃ x h ts tsʰ ɾ l j a e i u",

  // https://en.wikipedia.org/wiki/Akkadian_language#Phonetics_and_phonology
  Akkadian: "m n p t ts k ʔ t’ ts’ k’ b d dz g s ʃ x r l j w i u e a",

  // https://en.wikipedia.org/wiki/Egyptian_language#Phonology
  "Ancient Egyptian": "m n p t c k q ʔ b d ɟ ɡ f s ʃ ç χ ħ h z ʁ ʕ w l j r i iː u uː a aː",

  // https://en.wikipedia.org/wiki/Phoenician_language#Phonology
  // 𐤌:m 𐤍:n 𐤐:p 𐤕:t 𐤎:ts 𐤊:k 𐤀:ʔ 𐤈:ʈ 𐤑:ʈʂ 𐤒:q 𐤁:b 𐤃:d 𐤆:dz 𐤂:g 𐤔:ʃ 𐤇:ħ 𐤄:h 𐤓:r 𐤋:l 𐤉:j 𐤅:w 𐤏:ʕ
  Phoenician: "m n p t ts k ʔ ʈ ʈʂ q b d dz g ʃ ħ h r l j w ʕ i u iː uː e o eː oː a aː",

  // https://en.wikipedia.org/wiki/Classical_Nahuatl#Phonology
  "Classical Nahuatl": "m n p t k kʷ s ɬ ʃ ts tɬ tʃ l j w i iː o oː e eː a aː",


  //
  // https://en.wikipedia.org/wiki/Category:Proto-languages

  // https://en.wikipedia.org/wiki/Proto-Algonquian_language
  "Proto-Algonquian": "i e a o i· e· a· o· p t tʃ k s ʃ h θ m n w r j",

  // https://en.wikipedia.org/wiki/Proto-Bantu_language
  "Proto-Bantu": "i u ɪ ʊ e o a m n ɲ p t c k b d j g",

  // https://en.wikipedia.org/wiki/Proto-Celtic_language
  "Proto-Celtic": "iː i uː u eː e o aː a b t d k ɡ kʷ ɡʷ m n ɸ s x l j w r",

  // https://en.wikipedia.org/wiki/Proto-Dravidian_language
  "Proto-Dravidian": "a i u e o aː iː uː eː oː m n̪ n ɳ ɲ p t̪ t ʈ c k ɭ ɾ ʋ l ɻ j",

  // https://en.wikipedia.org/wiki/Proto-Oceanic_language
  // note: this doesn't capture "pre-nasalized", e.g., ᵐb ⁿd ᶮɟ
  "Proto-Oceanic": "a e i o u pʷ p t c k q bʷ b d ɟ ɡ mʷ m n ɲ ŋ s ɾ r l w j",
}
